import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { IPaymentCardCommonData } from '../../../../models/common/payments';
import { PHAlogo } from '../../../shared/images/PHAlogo';
import { PHABadge } from '../../pro-house-account-badge/PHA-badge';

export const ProHouseAccountInfo = ({
  proHouseAccount,
}: {
  proHouseAccount: IPaymentCardCommonData;
}) => {
  const { cardNumberLast4, locName, locType } = proHouseAccount;

  return (
    <div className="sui-flex sui-flex-col sui-gap-2">
      <div className="sui-flex sui-gap-2">
        {locName && <Typography weight="bold">{locName}</Typography>}
        {locType && <PHABadge locType={locType} />}
      </div>
      <div className="sui-flex sui-gap-4 sui-items-center">
        <PHAlogo />
        {cardNumberLast4 && (
          <div className="sui-mr-4">
            <Typography variant="body-lg" color="subtle">
              ****{cardNumberLast4}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};
